import { render, staticRenderFns } from "./WooSettings.vue?vue&type=template&id=151e92dc&"
import script from "./WooSettings.vue?vue&type=script&lang=js&"
export * from "./WooSettings.vue?vue&type=script&lang=js&"
import style0 from "./WooSettings.vue?vue&type=style&index=0&id=151e92dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports